import { triggerAjax } from './prime-core.js';

/**
 * Frontpage article loader and news selector filter.
 */

export function initFrontpage() {
  if ($('.frontpage-article-loader').length === 0) return;

  const sTheInitialArchiveHref = $('.archive-link').attr('href');

  // Initial load
  $('.frontpage-article-loader').empty().append(window.sTheLoader);

  window.Ajax.frontpage_articles(
    {
      template       : '.frontpage-article-loader',
      tournament_ids : $('.frontpage-article-loader').attr('data-tournament-ids')
        ? $('.frontpage-article-loader').attr('data-tournament-ids').split(',') : [],
      team_ids       : $('.frontpage-article-loader').attr('data-team-ids')
        ? $('.frontpage-article-loader').attr('data-team-ids').split(',') : [],
      initial        : true,
    },
    function(data) {
      $(data.param.template).empty().append(data.markup);

      // Trigger AJAX for any nested prime-data.v2 elements
      if ($(data.param.template).find('.prime-data.v2').length > 0) {
        $(data.param.template).find('.prime-data.v2').each(function(i) {
          const oTheContainer = $(this);
          const delay = (i + 1) * 100;
          setTimeout(() => triggerAjax(oTheContainer), delay);
        });
      }
    },
    function(data) { window.showError(data); }
  );

  // News type selector
  $(document).on('change', '#news_selector', function(e) {
    e.preventDefault();

    $('.frontpage-article-loader').empty().append(window.sTheLoader);

    const sTheArchiveHref = sTheInitialArchiveHref
      + '&type='       + $(this).find('option:selected').attr('data-type')
      + '&tournament=' + $(this).find('option:selected').attr('data-tournament-id')
      + '&category='   + $(this).find('option:selected').attr('data-cat-id')
      + '&tag='        + $(this).find('option:selected').attr('data-tag-id');

    $('.archive-link').attr('href', sTheArchiveHref);

    const initialSetting = $(this).find('option:selected').attr('data-type') === 'all';

    window.Ajax.frontpage_articles(
      {
        template       : '.frontpage-article-loader',
        initial        : initialSetting,
        type           : $(this).find('option:selected').attr('data-type'),
        tournament     : $(this).find('option:selected').attr('data-tournament-id'),
        category       : $(this).find('option:selected').attr('data-cat-id'),
        tag            : $(this).find('option:selected').attr('data-tag-id'),
        tournament_ids : $('.frontpage-article-loader').attr('data-tournament-ids')
          ? $('.frontpage-article-loader').attr('data-tournament-ids').split(',') : [],
        team_ids       : $('.frontpage-article-loader').attr('data-team-ids')
          ? $('.frontpage-article-loader').attr('data-team-ids').split(',') : [],
      },
      function(data) {
        $(data.param.template).empty().append(data.markup);
      },
      function(data) { window.showError(data); }
    );
  });
}



// WEBPACK FOOTER //
// ./scripts/routes/common/frontpage.js